module.exports = __webpack_public_path__ + "static/work66-0edde464c73d002d947941fbec7269e3.jpg";